import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = (props) => (
  <div style={{position:"relative"}}>
    <img alt="not found" src={"/static/404.jpg"} style={{width:"100vw",height:"98vh",left:"0",top:"0",objectFit:"cover"}}/>
    <p style={{textAlign:"center", position:"fixed",color:"white",left:"10vw",top:"0"}}>
        <h1>404</h1>
        <h4>Page Not Found</h4>
        <h2><Link to="/">Go to Home </Link></h2>
    </p>
  </div>
);


export default NotFound;